export enum FileTypeEnum {
    Mlatom = 'mlatom',
    Python = 'python',
    Text = 'text',
    XYZ = 'xyz',
    GAUSSIAN = 'gaussian',
    SMILES = 'smiles',
}

export const FileTypeToExtensionMap: Record<FileTypeEnum, string> = {
    [FileTypeEnum.Mlatom]: '.inp',
    [FileTypeEnum.Python]: '.py',
    [FileTypeEnum.Text]: '.txt',
    [FileTypeEnum.XYZ]: '.xyz',
    [FileTypeEnum.GAUSSIAN]: '.com',
    [FileTypeEnum.SMILES]: '.smi',
};